import { useAppDispatch, useAppSelector } from "store";

import { useEffect, useRef } from "react";
// @ts-ignore
import { loadProgressBar } from "axios-progress-bar";

import {
  getCart,
  getCatalogGroups,
  getPersonalData,
  getShops,
  getTerritoriesIndividuals,
  isLoginSelector,
  orderList,
  personalDataCitySelector,
  selectedStoreSelector,
  setSelectedStore,
  territoriesResultSelector,
  testToken
} from "features";
import { axiosExchange } from "services/axios";
import shopService from "services/shopService";


export const useInit = () => {
  // console.log("init")
  const dispatch = useAppDispatch();
  const deliveryMethod = localStorage.getItem("selectedOrderingMethod");
  const cityCurrent = localStorage.getItem("city");

  const isLogin = useAppSelector(isLoginSelector);

  const rawCodeTerritory = useAppSelector(personalDataCitySelector) ?? (cityCurrent ? +cityCurrent : 17);
  const codeTerritory = typeof rawCodeTerritory === 'string' ? +rawCodeTerritory : rawCodeTerritory;
  const territories = useAppSelector(territoriesResultSelector);
  const selectedStore = useAppSelector(selectedStoreSelector);
  
  const previousCodeTerritory = useRef<number | null>(null);

  const checkToken = async () => {
    await dispatch(testToken({}));
  };

  const loadData = async () => {
    await dispatch(getShops({}));
    await dispatch(getPersonalData({}));
    dispatch(getCart({
      ТипДоставки:
        deliveryMethod === "delivery"
          ? "ДоставкаИзМагазина"
          : "Самовывоз",
      ССайта: true,
    }));
    dispatch(orderList({}));
    shopService.getStores({});
  };

  useEffect(() => {
    dispatch(getTerritoriesIndividuals({}));
    loadProgressBar({}, axiosExchange);
    checkToken();
  }, []);

  useEffect(() => {
    const selectedStore = localStorage.getItem("selectedStore");

    if (selectedStore) {
      try {
        const parsedStore = JSON.parse(selectedStore);
        dispatch(setSelectedStore(parsedStore));
      } catch (e) {
        localStorage.removeItem("selectedStore");
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const initializeStore = async () => {
      const cityChanged = previousCodeTerritory.current !== null && 
                         previousCodeTerritory.current !== codeTerritory;
      const noStoreSelected = !selectedStore;
      
      if (codeTerritory && (noStoreSelected || cityChanged)) {
        try {
          const { data } = await shopService.getStoresByTerritory({ 
            КодТерритории: codeTerritory 
          });
          
          if (data.Data && data.Data.length > 0) {
            const firstStore = data.Data[0];
            dispatch(setSelectedStore(firstStore));
            localStorage.setItem("selectedStore", JSON.stringify(firstStore));
          }
        } catch (error) {
          console.error("Failed to load stores:", error);
        }
      }
      
      previousCodeTerritory.current = codeTerritory;
    };

    initializeStore();
  }, [selectedStore, codeTerritory, dispatch]);

  useEffect(() => {
    if (isLogin) {
      loadData();
    }
  }, [isLogin]);

  useEffect(() => {
    if (codeTerritory && territories.length) {
      dispatch(
        getCatalogGroups({
          КодТерритории: codeTerritory,
          Дискаунтер: true,
          ТорговыйОбъект: selectedStore?.Дискаунтер,
          ТипДоставки: "БезДоставки",
        })
      );
    } else {
      dispatch(
        getCatalogGroups({
          КодТерритории: 17,
          noauth: true,
          Дискаунтер: true,
          ТорговыйОбъект: selectedStore?.Дискаунтер,
          ТипДоставки: "БезДоставки",
        })
      );
    }
  }, [territories, codeTerritory, selectedStore]);
}
